import React from 'react';
import { motion } from 'framer-motion';

const products = [
  {
    id: 1,
    name: 'Aethelred Watch',
    price: '$1,200',
    image: 'https://media.rolex.com/image/upload/v1725888677/rolexcom/collection/configurator/config-launcher/2024/config-launcher-watches-datejust-m278274-0018_2403jva_002-portrait.jpg',
  },
  {
    id: 2,
    name: 'La Belle Parfum',
    price: '$180',
    image: 'https://cdn.shopify.com/s/files/1/0278/9723/3501/files/49-Richard-Mille-Brands.jpg',
  },
  {
    id: 3,
    name: 'Aurelian Bracelet',
    price: '$600',
    image: 'https://cdn.shopify.com/s/files/1/0612/0354/6292/files/Audemars_Piguet_Royal_Oak_Gold.jpg',
  },
  {
    id: 4,
    name: 'The Sovereign Pen',
    price: '$350',
    image: 'https://5.imimg.com/data5/SELLER/Default/2024/2/393870474/TU/BO/QZ/50922610/whatsapp-image-2024-02-27-at-2-28-21-pm-500x500.jpeg',
  },
];

const BestSellers = () => {
  const cardVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: i * 0.1,
        duration: 0.5,
        ease: 'easeOut',
      },
    }),
  };

  return (
    <div className="bg-luxury-cream py-20 font-sans">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-serif text-luxury-black text-center mb-4">Latest Release</h2>
        <p className="text-center text-luxury-black/70 mb-12 text-lg">
          Experience the pinnacle of craftsmanship and style.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {products.map((product, i) => (
            <motion.div
              key={product.id}
              className="group relative overflow-hidden rounded-lg shadow-lg bg-white"
              custom={i}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              variants={cardVariants}
            >
              <div className="overflow-hidden">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-80 object-cover transform transition-transform duration-500 ease-in-out group-hover:scale-110"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />
              <div className="p-6 absolute bottom-0 left-0 right-0">
                <h3 className="text-xl font-semibold text-white transition-opacity duration-300">
                  {product.name}
                </h3>
                <p className="text-white/80 text-lg">{product.price}</p>
              </div>
              <div className="absolute inset-0 bg-black/40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                <button className="text-white font-bold py-2 px-4 border-2 border-white rounded-full hover:bg-white hover:text-luxury-black transition-colors duration-300">
                  View Details
                </button>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BestSellers;